import * as React from 'react';
import VertexLinkProps from './VertexLinkProps.interface';
import './link.scss';

const VertexLink = ({
  href = null,
  onClick = null,
  display,
  additionalLinkStyleClass = null,
  color = 'gray',
}: VertexLinkProps): JSX.Element => { // eslint-disable-line  arrow-body-style
  const style = `vertexLinkStyle vertexLinkStyle-${color} ${additionalLinkStyleClass}`;

  if (href) {
    return (
      <a href={href}>
        {/* eslint-disable-next-line  react/button-has-type */}
        <button className={style}>
          {display}
        </button>
      </a>
    );
  }

  if (onClick) {
    return (
      /* eslint-disable-next-line  react/button-has-type */
      <button onClick={onClick} className={style}>
        {display}
      </button>
    );
  }

  return (<></>);
};

export default VertexLink;
